import React from "react"
import * as ReactIcons from '@src/lib/react-icons'
import './style.scss'

type SearchBarProps = {
  value: string
  handleOnChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  handleOnClick: () => void
}

const Setting: React.FC<SearchBarProps> = (props) => {
  const { value, handleOnChange, handleOnClick} = props
  return (
    <div className='search-bar'>
      <div className='search-bar-btn' onClick={handleOnClick}>
        <ReactIcons.FaSearch className='search-bar-icon' />
      </div>
      <input
        className='search-bar-input form-input'
        type='text'
        value={value}
        onChange={handleOnChange}
        placeholder=''
        aria-label='Search'
      />
    </div>
  );
};

export default Setting
